import * as React from "react"
import { useStaticQuery, Link, graphql } from "gatsby"
import { library, icon } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedinIn, faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faLocationDot } from '@fortawesome/free-solid-svg-icons'
import { Script } from "gatsby"

const Footer = ({ className }) => {
  library.add(faLinkedinIn, faFacebookF, faInstagram, faLocationDot);
  
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            footer {
              menuLinks {
                title
                links {
                  name
                  link
                  icon
                }
              },
              additionalText
            }
          }
        }
      }
    `
  )
  
  let legals = site.siteMetadata.footer.menuLinks.filter(item => item.title === 'Legal');
  let socials = site.siteMetadata.footer.menuLinks.filter(item => item.title === 'Social');
  let locations = site.siteMetadata.footer.menuLinks.filter(item => item.title === 'Locations');
  
  legals = legals.length ? legals[0] : null;
  socials = socials.length ? socials[0] : null;
  locations = locations.length ? locations[0] : null;

  React.useEffect(()=>{
    window.footerNewsletterInterval = setInterval(()=>{
      const formDiv = document.querySelector(".klaviyo-form-Yfb5Tc");
      const emailInput = document.querySelector(".klaviyo-form-Yfb5Tc input[type='email']");
      const button = document.querySelector(".klaviyo-form-Yfb5Tc button");
      const spans = document.querySelectorAll(".klaviyo-form-Yfb5Tc span:not(.font-sans)");

      if (spans.length > 0) {
        spans.forEach(span => {
          span.classList.add("font-sans");
        });
      }
  
      if (formDiv != null && emailInput != null && button != null) {
        if (formDiv.getAttribute("cssFixed")) {
          return;
        }
        formDiv.setAttribute("cssFixed", "true");
        formDiv.style.opacity = "1";
        formDiv.classList.add("font-sans");
        emailInput.setAttribute("style", "");

        let emailInputCssRemoveClass = "";
        emailInput.classList.forEach((item)=>{
          if (item.includes("kl-private-reset-css-")) {
            emailInputCssRemoveClass = item;
          }
        })
        if (emailInputCssRemoveClass.length > 0) {
          const elements = document.querySelectorAll("."+emailInputCssRemoveClass);
          for (var i = 0; i < elements.length; i++) {
              elements[i].classList.remove(emailInputCssRemoveClass);
          }
        }

        emailInput.className += " appearance-none !shadow-none font-sans block w-full h-12 bg-white text-gray-700 border rounded py-3 px-4 my-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 dark:bg-neutral-800 dark:border-neutral-700 dark:text-white";
        
        button.setAttribute("style", "");
        button.className += " bg-transparent hover:bg-gray-100 font-monospace uppercase focus:shadow-outline focus:outline-none text-latori-green py-3 px-4 rounded";

        button.parentElement.parentElement.style.alignItems = "center";

        clearInterval(window.footerNewsletterInterval);
      }else{
        if (formDiv != null && formDiv.getAttribute("cssFixed")) {
          return;
        }
        formDiv.style.opacity = "0";
      }
    },100);
    return () =>{
      clearInterval(window.footerNewsletterInterval);
    }
  })

  return (<>
    <Script src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=UjZT3H" strategy="idle" />
    <footer className={`bg-background-light dark:bg-background-footer-light md:dark:bg-background-footer-dark border-t border-latori-pink transition-all ${className}`}>
      <div className="px-4 lg:px-8 text-center lg:text-left">
        <div className="mx-auto max-w-screen-2xl py-10 text-center md:text-left">
          <div className="grid grid-1 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-8">
            <div className="flex justify-start md:justify-start flex-col gap-4 md:max-w-xs text-left">
              Newsletter
              <div className="klaviyo-form-Yfb5Tc min-h-[50px]"></div>
              {/* <input placeholder="Email-Adresse" className="rounded-none appearance-none bg-transparent border-background-dark dark:border-white border-b" type="email" id="email"/> */}
            </div>
            <div className="row-start-4 md:row-start-auto">
            {socials && (
                <ul className="flex flex-row justify-center md:justify-end lg:justify-center gap-4 items-end h-full">
                    {socials.links.map(social => {
                      return (
                        <li key={social.name}>
                          <a href={social.link} title={social.name} target="_blank" rel="noreferrer" className={`rounded-full overflow-hidden bg-background-dark dark:bg-white text-white dark:text-background-dark w-6 h-6 flex justify-center items-center text-sm${ social.icon === 'facebook-f' ? ' pt-[0.35rem] !text-xl' : '' }`}>
                            <FontAwesomeIcon icon={icon({prefix: 'fab', iconName: social.icon })} />
                          </a>
                        </li>
                      )}
                    )}
                </ul>
              )
            }
            </div>
            <div className="flex flex-row gap-4 justify-center md:justify-start lg:justify-end items-end h-full">
              {locations && (
                  <ul className="flex justify-center md:col-span-2 lg:col-span-3">
                    {locations.links.map((location, index) => {
                      return (
                        <li className={`flex gap-2 pr-4 border-background-dark dark:border-white leading-none${locations.links.length - 1 > index ? ' border-r-2' : ''}${locations.links.length - 1 === index ? ' pl-4 pr-0' : ''}`} key={location.name}>
                          <Link to="/about-us#locations"><FontAwesomeIcon icon={icon(faLocationDot)} /> {location.name}</Link>
                        </li>
                      )}
                    )}
                  </ul>
              )
            }
            </div>
            {legals && (
                <ul className="flex justify-center md:justify-end lg:justify-center lg:col-span-3">
                  {
                    legals.links.map((item, index) => {
                      return (
                        <li className={`pr-2 border-background-dark dark:border-white leading-none${legals.links.length - 1 > index ? ' border-r-2 pl-2' : ''}${legals.links.length - 1 === index ? ' pl-2 pr-0' : ''}`} key={item.name}>
                          <Link to={item.link}>{item.name}</Link>
                        </li>
                      )
                    })
                  }
                </ul>
                )
              }
              <div className="mx-auto md:col-span-2 lg:col-span-3 text-xs text-center opacity-50">{site.siteMetadata.footer.additionalText}</div>
          </div>
        </div>
      </div>
    </footer>
    </>
  )
}

export default Footer
